var map = {
	"./navigate-da-dk.png": 58858,
	"./navigate-de-de.png": 94497,
	"./navigate-en-gb.png": 93269,
	"./navigate-en-us.png": 77123,
	"./navigate-es-es.png": 98349,
	"./navigate-es-mx.png": 27084,
	"./navigate-fr-fr.png": 2099,
	"./navigate-it-it.png": 16097,
	"./navigate-nb-no.png": 98693,
	"./navigate-nl-nl.png": 45700,
	"./navigate-pl-pl.png": 85531,
	"./navigate-pt-br.png": 23540,
	"./navigate-pt-pt.png": 8258,
	"./navigate-sv-se.png": 29066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72563;